export async function multiselect(triggerId: string, fieldId: string, itemId: string, label: string, hasError: boolean, enabled: boolean = true) {

    await import('@syncfusion/ej2-base/styles/bootstrap4.css');
    await import('@syncfusion/ej2-buttons/styles/bootstrap4.css');

    await import('./loadSyncfusion');

    const { CheckBox } = await import('@syncfusion/ej2-buttons');

    const dataEle = document.getElementById('data_' + fieldId);
    const itemContainerEle = document.getElementById('container_' + fieldId + '_' + itemId);
    const inputEle = document.getElementById('input_' + fieldId + '_' + itemId);

    if (inputEle.hasAttribute("data-checkbox")) {
        (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
        return;
    }

    inputEle.setAttribute('data-checkbox', 'true');

    let dataEleVal = dataEle.getAttribute('value');
    let selectedItems = dataEleVal ? dataEleVal.split(',') : [];

    let ddObject = new CheckBox({
        label: label,
        disabled: !enabled,
        checked: selectedItems.indexOf(itemId) >= 0,
        change: (args: any) => {
            dataEleVal = dataEle.getAttribute('value');
            selectedItems = dataEleVal ? dataEleVal.split(',') : []

            if (ddObject.checked) {
                selectedItems.push(itemId);
            } else {
                selectedItems = selectedItems.filter((x: string) => x !== itemId);
            }

            dataEle.setAttribute('value', selectedItems.join(','));

            if (triggerId != '')
            {
                (document.getElementById(triggerId) as HTMLButtonElement).click();
            }
        },
        created: (args: any) => {
            (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
            itemContainerEle.style.display = null;
        }
    });

    ddObject.appendTo('#input_' + fieldId + '_' + itemId);
}